module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm03"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04#sec1"
    }
  }, [_vm._v("How I Was Drawn to My Great Leaders Vision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04#sec2"
    }
  }, [_vm._v("Next Step: Hospital Administrator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm04#sec3"
    }
  }, [_vm._v("Helping Good People Become Great Leaders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm05"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm05#sec1"
    }
  }, [_vm._v("What Can You Expect from On Course?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm05#sec2"
    }
  }, [_vm._v("What Does It Take to Become an ACE?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: Off Course")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What are the 5 Key Questions?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Importance of Leaders Getting Back On Course")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leadership versus Management")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Past and Present")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Complexity and Sacrifice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap01#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacrifices for Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Disengagement and Distractions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two-Edged Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Void")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Danger of Disengagement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap02#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Different Generations Different Perspectives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: “The Boss” – About Leaders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Reality Check About Leaders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Definitions of a Leader")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Peter Principle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Historical Examples of Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wish Fulfillment: Left Hand, Right Hand Concept")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abundance vs. Scarcity Mentality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap03#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Become an ACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Framework of the KiVisions Leader Development Process")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Myths of Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Phases in the Helping True Leaders Soar to Greatness Series"), _c('sup', [_vm._v("©")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap04#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gyroscope System")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Envisioning the Destination")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vision Test")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consistency of Vision/Mission/Actions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Value Proposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KiVisions Value Proposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discerning Your Personal Value Proposition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap05#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connection with ACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Achieving the Vision—7 Steps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 1. Establish a Mission Plan.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 2. Press-to-Test Your Plan.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 3. Execute the Plan.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 4. Periodically Measure Progress.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 5. Reflect and Decide on Necessary Action")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 6. Take Necessary Action")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap06#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step 7. Revisit Steps 1-6 Repeatedly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Balancing Forces in the Successful Ventures in Human Dynamics Model")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lift and Thrust: The Forces Necessary to Get Off the Ground and Climb")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drag and Weight: Forces that Hold Us Back and Keep Us Down")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("External Conditions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tactical Uses – Five Common Employee Concerns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap07#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Macro Perspective")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The 5 Prime Values")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Origin of the 5 Prime Values")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prime Value #1: Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prime Value #2: Learn, Continuously")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prime Value #3: Live")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prime Value #4: Laugh and Celebrate Life!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap08#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prime Value #5: Leave a Legendary Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Foundation for Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Pillars of the Foundation for Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chap09#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Proactive Approach: RAVOlUtion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Setting the Stage for Your Future")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making a Difference")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: The KiVisions Leader Development Process")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: Table of Qualities and Clarifying Questions for Leader Categories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: Glossary of Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix D: On Course Library")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix E: Ideas to Improve the U.S. Political System")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix F: Joe Tye, Values Coach, Inc., Bill of Responsibilities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fmt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0